<template>
  <div>
    <div class="bg-image" style="position: fixed; top: 0;left: 0; z-index: -1; background-image: url('b.png')">
      <div style="width: 100%; margin-top: 6%">
        <img src="2.png" style="width: 40%"></div>

      <div style="width: 100%; margin-top: 5%">
        <img src="1.png" style="width: 45%;"></div>

      <div style="width: 100%">
        <img src="q.jpg" style="width: 30%"></div>
      <span style="color: #FFFFFF;    font-size: 12px;">扫码关注公众号</span>
    </div>

    <div class="mask" v-if="showSuccess"></div>
    <div v-if="showCircle" align="center" style="position: absolute;margin-top: 45%;margin-left: 40%">
      <van-loading type="spinner" :size="width + 'px'" color="#000000ad"/>
    </div>

    <div>
      <transition name="amount">
        <div v-if="showSuccess" class="showMessage" style="background: url('success.png') no-repeat; position: fixed;
    z-index: 10;
    background-size: contain;
    width: 70%;
    height: 100%;
    margin-top: 20%;
    margin-left: 15%;">
          <label class="amount">{{amount}}</label>
          <img src="c.png" style=" width: 35px; height: 35px;float: right" @click="showSuccess = false">
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import common from '@/common/Common.js'
import axios from 'axios'

export default {
  name: 'hello',
  data () {
    return {
      showCircle: true,
      showSuccess: false,
      luckyCode: this.$route.query.luckyCode || null,
      wxCode: this.$route.query.code || null, // 微信code，用于授权登录
      width: window.outerWidth * 0.2,
      amount: '20 元'
    }
  },
  mounted () {
    this.wxLogin()
    if (this.wxCode !== null) {
      this.submitQrCode()
    }
  },
  methods: {
    // 微信登录
    wxLogin () {
      if (this.wxCode === null) {
        let locationHref = encodeURIComponent(location.href)
        window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + common.appId + '&redirect_uri=' +
            locationHref + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect')
      }
    },
    submitQrCode () {
      let that = this
      axios({
        method: 'post',
        url: common.apiUrl + '/api/lucky/submitCode',
        data: {
          luckyCode: that.luckyCode,
          wxCode: that.wxCode
        }
      }).then(function (response) {
        if (response.data.code === 0) {
          that.amount = response.data.data + ' 元'
          that.showSuccess = true
        } else {
          that.$notify({ message: response.data.message })
        }
        that.showCircle = false
      })
    }
  }
}
</script>
<style>
  .bg-image {
    background-size: cover;
    width: 100%;
    height: 100%;
  }

  .showMessage {

  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 9;
    background: rgba(0, 0, 0, 0.78)
  }

  .amount {
    font-size: 300%;
    display: inline-block;
    margin-top: 42%;
    margin-left: 18%;
    color: white;
    font-weight: bold
  }

  .amount-enter-active {
    animation: bounce-in 100ms;
  }

  .amount-leave-active {
    animation: bounce-in 100ms reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0.75);
    }
    20% {
      transform: scale(0.80);
    }
    40% {
      transform: scale(0.85);
    }
    60% {
      transform: scale(0.9);
    }
    80% {
      transform: scale(0.95);
    }
    100% {
      transform: scale(1);
    }
  }
</style>
